import { render, staticRenderFns } from "./LayoutFull.vue?vue&type=template&id=307a1daa"
import script from "./LayoutFull.vue?vue&type=script&lang=js"
export * from "./LayoutFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('307a1daa')) {
      api.createRecord('307a1daa', component.options)
    } else {
      api.reload('307a1daa', component.options)
    }
    module.hot.accept("./LayoutFull.vue?vue&type=template&id=307a1daa", function () {
      api.rerender('307a1daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/full/LayoutFull.vue"
export default component.exports